import {
  MotifCard,
  MotifCardHeader,
  MotifCardBody,
  MotifCardImage,
} from "../../assets/lib/motif";
import axios from "axios";
import { ENGAGEMENT_URL } from "../../store/services/endpoints/engagement";
import { useNavigate } from "react-router-dom";
import "./Home.scss";
// Image imports - WebP with fallbacks
import homePageBgWebp from "../../assets/Images/home-page-bg.webp";
import homePageBgJpg from "../../assets/Images/home-page-bg.jpg";
import homeThumb1Webp from "../../assets/Images/home-thumb1.webp";
import homeThumb1Png from "../../assets/Images/home-thumb1.png";
import homeThumb2Webp from "../../assets/Images/home-thumb2.webp";
import homeThumb2Png from "../../assets/Images/home-thumb2.png";
import homeThumb3Webp from "../../assets/Images/home-thumb3.webp";
import homeThumb3Jpg from "../../assets/Images/home-thumb3.jpg";
import homeThumb4Webp from "../../assets/Images/home-thumb4.webp";
import homeThumb4Jpg from "../../assets/Images/home-thumb4.jpg";
import { routes } from "../../routes/routes.constatns";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  homeHeader,
  homeHeaderBody,
  homescreencards,
  CreateNewEngBtn,
  homeViewDashboard,
  homeSolutionModules,
  CreateDemoEngBtn,
  COMMON_ERROR_MESSAGE,
  sandboxEngAccessFlag
} from "../../util/constants";
import { Button } from "../CommonUIComponents/Button/Button";
import { UsersConsent } from "../UsersConsent/UsersConsent";
import { dropEngagementState } from "../../store/slices/engagementSlice";
import { SelectRegionModal } from "../SelectRegionModal/SelectRegionModal";
import { LoadingIndicatorEmbed } from "../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { DemoEngagementConfirmModal } from "../DemoEngagementModal/DemoEngagementConfirmModal";
import { DemoEngagementSuccessModal } from "../DemoEngagementModal/DemoEngagementSuccessModal";
import { ImportSandboxEngagementObj } from "../../store/services/engagement.service";
import { useRegRedirectionAuthTokenAPAC } from "../../hooks/useAppRedirectionTokenAPAC";
import { useRegRedirectionAuthTokenUS } from "../../hooks/useAppRedirectionTokenUS";
import { useRegRedirectionAuthTokenEU } from "../../hooks/useAppRedirectionTokenEU";
import { MotifTooltip } from "../../assets/lib/motif";

// Image map for efficient access
const imageMap = {
  "home-page-bg": { webp: homePageBgWebp, fallback: homePageBgJpg },
  "home-thumb1": { webp: homeThumb1Webp, fallback: homeThumb1Png },
  "home-thumb2": { webp: homeThumb2Webp, fallback: homeThumb2Png },
  "home-thumb3": { webp: homeThumb3Webp, fallback: homeThumb3Jpg },
  "home-thumb4": { webp: homeThumb4Webp, fallback: homeThumb4Jpg },
};

function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const userConsent = useSelector(
    (state) => state.engagement?.externalUserFlag
  );
  const demoEngFlag = useSelector(
    (state) => state.engagement?.sandboxEngUserFlag
  );
  const selectedRegionForDemoEngagement = useSelector(
    (state) => state?.engagement?.selectedRegionForDemoEng
  );
  const [isDemoEngConfirmModalVisible, setIsDemoEngConfirmModalVisible] = useState(false);
  const [isDemoEngSuccessModalVisible, setIsDemoEngSuccessModalVisible] = useState(false);
  const [isSelectRegionVisible, setIsSelectRegionVisible] = useState(false);
  const [isSandboxEngagement, setIsSandboxEngagement] = useState(false);
  const [loader, setLoader] = useState(true);
  const [sandboxErrorMessage, setSandboxErrorMessage] = useState("");
  const [demoEngLoader, setDemoEngLoader] = useState(false);

  const token_APAC = useRegRedirectionAuthTokenAPAC();
  const token_US = useRegRedirectionAuthTokenUS();
  const token_EU = useRegRedirectionAuthTokenEU();

  function viewEngagementPage() {
    // navigate(`/${routes.viewEngagement}`, { gestureEnabled: false });
    window.location.href = `${process.env.REACT_APP_URL_REG_ALL}${routes.viewEngagement}`;
  }

  function handelDemoEngConfirmCancel() {
    setIsDemoEngConfirmModalVisible(false);
    dispatch(dropEngagementState());
    setSandboxErrorMessage("");
  }

  function handelDemoEngSuccessModalCancel() {
    setIsDemoEngSuccessModalVisible(false);
    dispatch(dropEngagementState());
    viewEngagementPage();
  }

  function handelDemoEngSuccessModalConfirm() {
    setIsDemoEngSuccessModalVisible(false);
    dispatch(dropEngagementState());
    viewEngagementPage();
  }

  function handleCreateEngagement() {
    setIsSelectRegionVisible(true);
    dispatch(dropEngagementState());
    /* Bhushan - Removed this API call as this is duplicate
      Allready called in SideMenu.jsx
    */
    // dispatch(getUserConsent({ email: user.username }));
  }

  function handleDemoEngClick() {
    setIsSandboxEngagement(true);
    handleCreateEngagement();
  }

  async function createDemoEng() {
    try {
      console.log("Creating demo engagement in region:", selectedRegionForDemoEngagement);
      setDemoEngLoader(true);
      const selectedRegionId = selectedRegionForDemoEngagement?.id ?? selectedRegionForDemoEngagement?.regionID;  
      let token = token_EU; 
      if(selectedRegionId === 1) {
        console.log('regionID 1')
        token = token_US;
      } else if(selectedRegionId === 2) {
        console.log('regionID 2')
        token = token_APAC;
      } else if(selectedRegionId === 3) {
        console.log('regionID 3')
        token = token_EU;
      }
      let response = {};
      if (process.env.REACT_APP_MULTI_REGION_ALLOW === 'true') {
        response = await axios.post(
          `${selectedRegionForDemoEngagement?.apiUrl}WebApi/Invoke`,
          ImportSandboxEngagementObj,
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        const config = {
          withCredentials: true,
          sameSite: "Strict",
          "X-Frame-Options": "DENY",
          "Content-Security-Policy": "frame-ancestors 'none'",
        };

        response = await axios.post(
          `/WebApi/Invoke`,
          ImportSandboxEngagementObj,
          config
        );
      }
      const res = response?.data;
      console.log("API Response:", res);
      /**
       * Success Case → 200
       */
      if (res?.statusCode === 200) {
        setIsDemoEngConfirmModalVisible(false);
        setIsDemoEngSuccessModalVisible(true);
        setDemoEngLoader(false);
        return res;
      }

      // Fallback for anything else (rare)
      setDemoEngLoader(false);
      setSandboxErrorMessage(COMMON_ERROR_MESSAGE);
      return res;

    } catch (error) {
      console.error("Caught Axios Error:", error);
      setDemoEngLoader(false);
      setSandboxErrorMessage(COMMON_ERROR_MESSAGE);
      return null;
    }
  }

  const renderCards = () => {
    return homescreencards.map((element) => {
      const images = imageMap[element.image];
      return (
        <MotifCard className="home-bottom-cards-card" key={crypto.randomUUID()}>
          <MotifCardImage className="home-bottom-cards-card-image">
            <picture>
              <source srcSet={images?.webp} type="image/webp" />
              <img
                src={images?.fallback}
                alt={element.heading}
                loading="lazy"
                decoding="async"
                onLoad={(e) => e.target.classList.add('loaded')}
              />
            </picture>
          </MotifCardImage>
          <MotifCardHeader
            variant="alt"
            className="home-bottom-cards-card-header"
          >
            <span>{element.heading}</span>
          </MotifCardHeader>
          <MotifCardBody className="home-bottom-cards-card-body">
            <span>{element.description}</span>
          </MotifCardBody>
        </MotifCard>
      );
    });
  };

  useEffect(() => {
    setLoader(true);
    /* Bhushan - Removed this API call as this is duplicate
      Allready called in SideMenu.jsx
    */
    // if (user?.username) dispatch(getUserConsent({ email: user.username }));
  }, [user?.username]);

  useEffect(() => {
    if (userConsent) {
      viewEngagementPage();
    }
    setLoader(false);
  }, [userConsent]);

  return (
    <LoadingIndicatorEmbed show={loader} fullscreen={false}>
      {userConsent === false && (
        <div className="home">
          <div className="home-top">
            <MotifCard className="home-top-welcome-card">
              <MotifCardHeader className="home-top-welcome-card-header">
                <span className="home-top-welcome-card-header-title">
                  {homeHeader}
                </span>
              </MotifCardHeader>
              <MotifCardBody className="home-top-welcome-card-body">
                <p>{homeHeaderBody}</p>
                <div className="home-top-welcome-card-footer-buttons">
                  {userConsent === false && (
                    <Button
                      className="home-top-welcome-card-footer-button"
                      variant="primary"
                      onClick={handleCreateEngagement}
                      disabled={userConsent !== false}
                    >
                      {CreateNewEngBtn}
                    </Button>
                  )}
                  {(demoEngFlag !== sandboxEngAccessFlag.NO_ACCESS 
                  && demoEngFlag === sandboxEngAccessFlag.HAS_EXISTING_SANDBOX_ENG) ? (
                      <MotifTooltip
                        className="tooltip-icon home-demo-engagement-tooltip"
                        children={<>Only one sandbox engagement can be created at a time. To create a new one, please delete the existing one</>}
                        placement="bottom"
                        hideCloseButton="true"
                        variant="alt"
                        usePortal={false}
                        offset={[0, 8]}
                        trigger={
                          <Button
                            className="home-top-welcome-card-footer-button alt"
                            variant={
                              demoEngFlag === sandboxEngAccessFlag.HAS_EXISTING_SANDBOX_ENG 
                              ? "primary" : "secondary"
                            }
                            onClick={handleDemoEngClick}
                            disabled={demoEngFlag === sandboxEngAccessFlag.HAS_EXISTING_SANDBOX_ENG}
                          >
                            {CreateDemoEngBtn}
                          </Button>
                        }
                    />) : demoEngFlag !== sandboxEngAccessFlag.NO_ACCESS &&
                      demoEngFlag === sandboxEngAccessFlag.HAS_ACCESS &&(
                      <Button
                        className="home-top-welcome-card-footer-button alt"
                        variant={"secondary"}
                        onClick={handleDemoEngClick}
                      >
                        {CreateDemoEngBtn}
                      </Button>
                    )
                  }
                  <Button
                    className="home-top-welcome-card-footer-button alt"
                    variant="secondary"
                    onClick={viewEngagementPage}
                  >
                    {homeViewDashboard}
                  </Button>
                </div>
              </MotifCardBody>
            </MotifCard>
            <span className="home-bottom-header">{homeSolutionModules}</span>
            <div className="home-bottom-cards">{renderCards()}</div>
          </div>
          <div className="home-bottom">
          </div>
          <UsersConsent />
          <SelectRegionModal
            isModalVisible={isSelectRegionVisible}
            onSubmit={() => {
              if (isSandboxEngagement) {
                setIsDemoEngConfirmModalVisible(true);
              }
            }}
            onClose={() => {
              setIsSelectRegionVisible(false); 
              setIsSandboxEngagement(false);
            }}
            isSandboxEngagement={isSandboxEngagement}
          />
          <DemoEngagementConfirmModal
            isModalVisible={isDemoEngConfirmModalVisible}
            onClose={handelDemoEngConfirmCancel}
            onConfirm={() => {
              createDemoEng();
            }}
            errorMessage={sandboxErrorMessage}
            demoEngLoader={demoEngLoader}
          />
          <DemoEngagementSuccessModal
            isModalVisible={isDemoEngSuccessModalVisible}
            onClose={handelDemoEngSuccessModalCancel}
            onConfirm={handelDemoEngSuccessModalConfirm}
          />
        </div>
      )}
    </LoadingIndicatorEmbed>
  );
}

export default Home;
